import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';

const HomePage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we have a scrollTo element in the state
    const state = location.state as { scrollTo?: string };
    if (state?.scrollTo) {
      const element = document.getElementById(state.scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
      // Clear the state
      window.history.replaceState({}, '');
    }
  }, [location]);

  return (
    <div>
      <Hero />
      <Features />
      <Testimonials />
      <CallToAction />
    </div>
  );
};

export default HomePage;